(function() {
  'use strict';

  angular.module('blocks.dropsearch', []);
})();
